import React from 'react'
import PropTypes from 'prop-types'
import { VIEWS } from '../hooks/useExportModal'

const ModalFooter = ({
  currentView,
  currentStep,
  loading,
  onBack,
  onExcelExport,
  onPDFExport,
  onClose
}) => {
  const showBackButton = currentStep > 0
  const showExportButton = [VIEWS.EXCEL_CUSTOM, VIEWS.PDF_OPTIONS].includes(currentView)

  return (
    <>
      {showBackButton ? (
        <button
          type="button"
          className="btn btn-secondary"
          disabled={loading}
          onClick={onBack}
        >
          Précédent
        </button>
      ) : (
        <button
          type="button"
          className="btn btn-secondary"
          disabled={loading}
          onClick={onClose}
        >
          Fermer
        </button>
      )}
      {showExportButton ? (
        <button
          type="button"
          className="btn btn-primary"
          disabled={loading}
          onClick={(() => {
            switch (currentView) {
            case VIEWS.PDF_OPTIONS:
              return onPDFExport
            default:
              return onExcelExport
            }
          })()}
        >
          {loading ? 'Export en cours...' : 'Exporter'}
        </button>
      ) : null}
    </>
  )
}

ModalFooter.propTypes = {
  currentStep: PropTypes.number.isRequired,
  currentView: PropTypes.oneOf(Object.values(VIEWS)).isRequired,
  loading: PropTypes.bool,
  onBack: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onExcelExport: PropTypes.func.isRequired,
  onPDFExport: PropTypes.func.isRequired
}

ModalFooter.defaultProps = {
  loading: false
}

export default ModalFooter